import { Employee } from '@/types/labor'

export const mockEmployees: Employee[] = [
  {
    id: '1',
    name: 'John Doe',
    position: 'Manager',
    department: 'Operations',
    hourlyRate: 35.0,
    hoursWorked: 160,
    isActive: true,
    startDate: '2022-01-15',
    email: 'john.doe@company.com',
    phone: '+1 (555) 123-4567',
    employeeNumber: 'EMP001',
    location: 'New York',
  },
  {
    id: '2',
    name: 'Jane Smith',
    position: 'Supervisor',
    department: 'Operations',
    hourlyRate: 28.5,
    hoursWorked: 155,
    isActive: true,
    startDate: '2021-06-20',
    email: 'jane.smith@company.com',
    phone: '+1 (555) 234-5678',
    employeeNumber: 'EMP002',
    location: 'Los Angeles',
  },
  {
    id: '3',
    name: 'Mike Johnson',
    position: 'Team Lead',
    department: 'Kitchen',
    hourlyRate: 25.0,
    hoursWorked: 168,
    isActive: true,
    startDate: '2023-03-10',
    email: 'mike.johnson@company.com',
    phone: '+1 (555) 345-6789',
    employeeNumber: 'EMP003',
    location: 'Chicago',
  },
  {
    id: '4',
    name: 'Sarah Williams',
    position: 'Cook',
    department: 'Kitchen',
    hourlyRate: 18.5,
    hoursWorked: 152,
    isActive: true,
    startDate: '2023-08-05',
    email: 'sarah.williams@company.com',
    phone: '+1 (555) 456-7890',
    employeeNumber: 'EMP004',
    location: 'Houston',
  },
  {
    id: '5',
    name: 'David Brown',
    position: 'Server',
    department: 'Front of House',
    hourlyRate: 15.0,
    hoursWorked: 140,
    isActive: true,
    startDate: '2024-01-10',
    email: 'david.brown@company.com',
    phone: '+1 (555) 567-8901',
    employeeNumber: 'EMP005',
    location: 'Phoenix',
  },
  {
    id: '6',
    name: 'Emily Davis',
    position: 'Bartender',
    department: 'Front of House',
    hourlyRate: 17.5,
    hoursWorked: 145,
    isActive: true,
    startDate: '2023-11-20',
    email: 'emily.davis@company.com',
    phone: '+1 (555) 678-9012',
    employeeNumber: 'EMP006',
    location: 'Philadelphia',
  },
  {
    id: '7',
    name: 'Robert Miller',
    position: 'Dishwasher',
    department: 'Kitchen',
    hourlyRate: 14.0,
    hoursWorked: 160,
    isActive: false,
    startDate: '2020-05-15',
    email: 'robert.miller@company.com',
    phone: '+1 (555) 789-0123',
    employeeNumber: 'EMP007',
    location: 'San Antonio',
  },
  {
    id: '8',
    name: 'Lisa Anderson',
    position: 'Host',
    department: 'Front of House',
    hourlyRate: 14.5,
    hoursWorked: 120,
    isActive: true,
    startDate: '2024-02-01',
    email: 'lisa.anderson@company.com',
    phone: '+1 (555) 890-1234',
    employeeNumber: 'EMP008',
    location: 'San Diego',
  },
  {
    id: '9',
    name: 'James Wilson',
    position: 'Cook',
    department: 'Kitchen',
    hourlyRate: 19.0,
    hoursWorked: 158,
    isActive: true,
    startDate: '2023-04-12',
    email: 'james.wilson@company.com',
    phone: '+1 (555) 901-2345',
    employeeNumber: 'EMP009',
    location: 'New York',
  },
  {
    id: '10',
    name: 'Patricia Martinez',
    position: 'Server',
    department: 'Front of House',
    hourlyRate: 15.5,
    hoursWorked: 138,
    isActive: true,
    startDate: '2024-03-01',
    email: 'patricia.martinez@company.com',
    phone: '+1 (555) 012-3456',
    employeeNumber: 'EMP010',
    location: 'Los Angeles',
  },
  {
    id: '11',
    name: 'Christopher Garcia',
    position: 'Cashier',
    department: 'Front of House',
    hourlyRate: 14.0,
    hoursWorked: 125,
    isActive: true,
    startDate: '2023-09-15',
    email: 'christopher.garcia@company.com',
    phone: '+1 (555) 123-7890',
    employeeNumber: 'EMP011',
    location: 'Chicago',
  },
  {
    id: '12',
    name: 'Barbara Rodriguez',
    position: 'Supervisor',
    department: 'Kitchen',
    hourlyRate: 27.0,
    hoursWorked: 160,
    isActive: true,
    startDate: '2022-07-20',
    email: 'barbara.rodriguez@company.com',
    phone: '+1 (555) 234-8901',
    employeeNumber: 'EMP012',
    location: 'Houston',
  },
  {
    id: '13',
    name: 'Daniel Lee',
    position: 'Cook',
    department: 'Kitchen',
    hourlyRate: 18.0,
    hoursWorked: 165,
    isActive: true,
    startDate: '2023-05-18',
    email: 'daniel.lee@company.com',
    phone: '+1 (555) 345-9012',
    employeeNumber: 'EMP013',
    location: 'Phoenix',
  },
  {
    id: '14',
    name: 'Nancy Taylor',
    position: 'Host',
    department: 'Front of House',
    hourlyRate: 14.5,
    hoursWorked: 115,
    isActive: true,
    startDate: '2024-01-20',
    email: 'nancy.taylor@company.com',
    phone: '+1 (555) 456-0123',
    employeeNumber: 'EMP014',
    location: 'Philadelphia',
  },
  {
    id: '15',
    name: 'Matthew Thomas',
    position: 'Bartender',
    department: 'Front of House',
    hourlyRate: 18.0,
    hoursWorked: 148,
    isActive: true,
    startDate: '2023-08-10',
    email: 'matthew.thomas@company.com',
    phone: '+1 (555) 567-1234',
    employeeNumber: 'EMP015',
    location: 'San Diego',
  },
  {
    id: '16',
    name: 'Betty Jackson',
    position: 'Team Lead',
    department: 'Operations',
    hourlyRate: 26.0,
    hoursWorked: 162,
    isActive: true,
    startDate: '2022-11-05',
    email: 'betty.jackson@company.com',
    phone: '+1 (555) 678-2345',
    employeeNumber: 'EMP016',
    location: 'New York',
  },
  {
    id: '17',
    name: 'Anthony White',
    position: 'Dishwasher',
    department: 'Kitchen',
    hourlyRate: 14.0,
    hoursWorked: 155,
    isActive: true,
    startDate: '2023-12-01',
    email: 'anthony.white@company.com',
    phone: '+1 (555) 789-3456',
    employeeNumber: 'EMP017',
    location: 'San Antonio',
  },
  {
    id: '18',
    name: 'Sandra Harris',
    position: 'Server',
    department: 'Front of House',
    hourlyRate: 15.0,
    hoursWorked: 142,
    isActive: false,
    startDate: '2021-03-15',
    email: 'sandra.harris@company.com',
    phone: '+1 (555) 890-4567',
    employeeNumber: 'EMP018',
    location: 'Los Angeles',
  },
  {
    id: '19',
    name: 'Mark Martin',
    position: 'Cook',
    department: 'Kitchen',
    hourlyRate: 19.5,
    hoursWorked: 170,
    isActive: true,
    startDate: '2023-06-22',
    email: 'mark.martin@company.com',
    phone: '+1 (555) 901-5678',
    employeeNumber: 'EMP019',
    location: 'Chicago',
  },
  {
    id: '20',
    name: 'Ashley Thompson',
    position: 'Cashier',
    department: 'Front of House',
    hourlyRate: 14.5,
    hoursWorked: 130,
    isActive: true,
    startDate: '2024-02-15',
    email: 'ashley.thompson@company.com',
    phone: '+1 (555) 012-6789',
    employeeNumber: 'EMP020',
    location: 'Houston',
  },
  {
    id: '21',
    name: 'Donald Garcia',
    position: 'Manager',
    department: 'Management',
    hourlyRate: 38.0,
    hoursWorked: 165,
    isActive: true,
    startDate: '2021-08-10',
    email: 'donald.garcia@company.com',
    phone: '+1 (555) 123-8901',
    employeeNumber: 'EMP021',
    location: 'Phoenix',
  },
  {
    id: '22',
    name: 'Carol Martinez',
    position: 'Supervisor',
    department: 'Front of House',
    hourlyRate: 26.5,
    hoursWorked: 158,
    isActive: true,
    startDate: '2022-09-05',
    email: 'carol.martinez@company.com',
    phone: '+1 (555) 234-9012',
    employeeNumber: 'EMP022',
    location: 'Philadelphia',
  },
  {
    id: '23',
    name: 'Steven Robinson',
    position: 'Cook',
    department: 'Kitchen',
    hourlyRate: 17.5,
    hoursWorked: 160,
    isActive: true,
    startDate: '2023-10-12',
    email: 'steven.robinson@company.com',
    phone: '+1 (555) 345-0123',
    employeeNumber: 'EMP023',
    location: 'San Diego',
  },
  {
    id: '24',
    name: 'Michelle Clark',
    position: 'Bartender',
    department: 'Front of House',
    hourlyRate: 17.0,
    hoursWorked: 144,
    isActive: true,
    startDate: '2023-07-25',
    email: 'michelle.clark@company.com',
    phone: '+1 (555) 456-1234',
    employeeNumber: 'EMP024',
    location: 'New York',
  },
  {
    id: '25',
    name: 'Paul Rodriguez',
    position: 'Server',
    department: 'Front of House',
    hourlyRate: 15.5,
    hoursWorked: 135,
    isActive: true,
    startDate: '2024-01-05',
    email: 'paul.rodriguez@company.com',
    phone: '+1 (555) 567-2345',
    employeeNumber: 'EMP025',
    location: 'Los Angeles',
  },
  {
    id: '26',
    name: 'Donna Lewis',
    position: 'Host',
    department: 'Front of House',
    hourlyRate: 14.0,
    hoursWorked: 118,
    isActive: false,
    startDate: '2022-04-20',
    email: 'donna.lewis@company.com',
    phone: '+1 (555) 678-3456',
    employeeNumber: 'EMP026',
    location: 'Chicago',
  },
  {
    id: '27',
    name: 'Kevin Walker',
    position: 'Team Lead',
    department: 'Kitchen',
    hourlyRate: 24.5,
    hoursWorked: 167,
    isActive: true,
    startDate: '2022-12-15',
    email: 'kevin.walker@company.com',
    phone: '+1 (555) 789-4567',
    employeeNumber: 'EMP027',
    location: 'Houston',
  },
  {
    id: '28',
    name: 'Laura Hall',
    position: 'Dishwasher',
    department: 'Kitchen',
    hourlyRate: 14.5,
    hoursWorked: 158,
    isActive: true,
    startDate: '2023-11-08',
    email: 'laura.hall@company.com',
    phone: '+1 (555) 890-5678',
    employeeNumber: 'EMP028',
    location: 'Phoenix',
  },
  {
    id: '29',
    name: 'Jason Allen',
    position: 'Cook',
    department: 'Kitchen',
    hourlyRate: 18.5,
    hoursWorked: 163,
    isActive: true,
    startDate: '2023-05-30',
    email: 'jason.allen@company.com',
    phone: '+1 (555) 901-6789',
    employeeNumber: 'EMP029',
    location: 'San Antonio',
  },
  {
    id: '30',
    name: 'Karen Young',
    position: 'Cashier',
    department: 'Front of House',
    hourlyRate: 14.0,
    hoursWorked: 128,
    isActive: true,
    startDate: '2024-03-10',
    email: 'karen.young@company.com',
    phone: '+1 (555) 012-7890',
    employeeNumber: 'EMP030',
    location: 'Philadelphia',
  },
]

export const DEPARTMENTS = [
  'Operations',
  'Kitchen',
  'Front of House',
  'Management',
  'Administration',
]

export const POSITIONS = [
  'Manager',
  'Supervisor',
  'Team Lead',
  'Cook',
  'Server',
  'Bartender',
  'Dishwasher',
  'Host',
  'Cashier',
]

export const LOCATIONS = [
  'New York',
  'Los Angeles',
  'Chicago',
  'Houston',
  'Phoenix',
  'Philadelphia',
  'San Antonio',
  'San Diego',
]

